<template>
    <div>
        <div v-show="paymentMethods.length">
            <div v-if="config.modules.demo_mode">
                <!-- DEMO MODE -->
                <div class="row">
                    <div v-for="paymentMethod in paymentMethods" :key='paymentMethod.code' class="col-md-2 d-flex mb-3">
                        <div class="btn bg-white cursor-no-drop border text-center p-2 d-flex flex-column align-items-center justify-content-center w-100">
                            {{ paymentMethod.name }}
                        </div>
                    </div>
                </div>
                <div v-if="paymentMethods.length" class="bg-light p-3 d-inline-block mt-2">
                    <i class="fas fa-exclamation-circle fa-lg me-1"></i> {{t.demo_mode.checkout_disclaimer}}
                </div>
            </div>
            <form v-else @submit.prevent="submitPayment" @keydown="formPayment.onKeydown($event)">
                <div v-if="cart.total > 0">
                    <!-- <h2 class="h5">{{ t.checkout.payment}}</h2> -->
                    <!-- <div v-if="paymentMethodsLoaded && paymentMethods.length > 1" class="row">
                        <div v-for="paymentMethod in paymentMethods" :key='paymentMethod.code' class="col-md-2 d-flex mb-3">
                            <div class="btn text-center p-2 d-flex flex-column align-items-center justify-content-center w-100 tooltip-css"
                                :class="{
                                    'bg-white border': paymentMethod.code != formPayment.payment_method,
                                    'btn-primary': paymentMethod.code == formPayment.payment_method
                                }"
                                :disabled="formPayment.busy"
                                @click="selectPaymentMethod(paymentMethod)">
                                {{ paymentMethod.name }}
                            </div>
                        </div>
                    </div> -->
                    <!-- display radio buttons for every payment methods -->
                    <div v-if="paymentMethodsLoaded && paymentMethods.length > 1" class="d-flex">
                        <div class="me-4" v-for="paymentMethod in paymentMethods" :key='paymentMethod.code'>
                            <input type="radio" :id="paymentMethod.code" :value="paymentMethod.code" v-model="formPayment.payment_method" :disabled="formPayment.busy">
                            <label :for="paymentMethod.code" class="cursor-pointer">{{ paymentMethod.name }}</label>
                        </div>
                    </div>
                    <div v-else-if="!paymentMethodsLoaded">{{ t.global.loading }}...</div>
                    <!-- <div v-else-if="paymentMethodsLoaded" class="h4 mb-3">{{ paymentMethods[0].name }}</div> -->
                    <div class="mb-3" v-show="formPayment.payment_method == 'atm'">
                        <div class="fw-bold mb-3">{{ t.checkout.atm_payment_instructions}}</div>
                        <div><b>{{ t.checkout.account_name }}</b> {{ settings.account_name }}</div>
                        <div><b>{{ t.checkout.bank_name }}</b> {{ settings.bank_name }}</div>
                        <div><b>{{ t.checkout.branch_name }}</b> {{ settings.branch_name }}</div>
                        <div><b>{{ t.checkout.account_number }}</b> {{ settings.account_number }}</div>
                        <div class="mb-3"><b>{{ t.checkout.bank_code }}</b> {{ settings.bank_code }}</div>
                        <label class="w-100" for="last_digits">{{ t.checkout.last_digits}}<span class="text-danger">*</span></label>
                        <input type="text" class="form-control w-auto" name="last_digits" id="last_digits" v-model="formPayment.last_digits" :disabled="formPayment.busy">
                        <div class="text-danger" v-if="formPayment.errors.has('last_digits')" v-html="formPayment.errors.get('last_digits')"></div>
                    </div>
                    <div class="text-danger mb-3" v-if="formPayment.errors.has('payment_method')" v-html="formPayment.errors.get('payment_method')"></div>
                </div>
                <div v-else class="alert alert-success">{{ t.checkout.cart_is_free}}</div>
                <div v-show="formPayment.payment_method == 'paypal_button'">
                    <div v-show="!formPayment.busy">
                        <div id="paypal-button-container"></div>
                        <div class="mt-1 mb-2">{{t.payment.accept_terms_and_conditions_payment_btn}}, <a class="text-underline" :href="url('terms-and-conditions')">{{ t.checkout.terms_and_conditions}}</a></div>
                    </div>
                    <div v-show="formPayment.busy" class="mb-2">{{t.checkout.processing+'...'}}</div>
                    <button class="btn btn-secondary mt-2" type="button" :disabled="formPayment.busy" @click="$listeners.back()">{{ t.global.back}}</button>
                </div>
                <div v-show="formPayment.payment_method == 'stripe'">
                    <div id="payment-element" class="form-group mb-3">
                        <!-- Elements will create input elements here -->
                    </div>
                    <!-- We'll put the error messages in this element -->
                    <div v-show="stripeError" class="text-danger mt-1 mb-3">{{stripeError}}</div>
                    <div v-show="!stripeInitiated" class="mb-3">{{ t.global.loading }}...</div>
                </div>
                <div v-show="formPayment.payment_method != 'paypal_button'">
                    <input type="checkbox" name="terms_and_conditions" id="terms_and_conditions" v-model="formPayment.terms_and_conditions" :disabled="formPayment.busy">
                    <label for="terms_and_conditions">{{ t.checkout.accept_terms_and_conditions}} <a class="text-underline" :href="url('terms-and-conditions')">{{ t.checkout.terms_and_conditions}}</a><span class="text-danger">*</span></label>
                    <div class="text-danger" v-if="formPayment.errors.has('terms_and_conditions')" v-html="formPayment.errors.get('terms_and_conditions')"></div>
                </div>
                <div v-show="formPayment.payment_method == 'stripe'" class="mt-3">
                    <!-- Stripe buttons -->
                    <button class="btn btn-secondary me-2" type="button" :disabled="stripePaymentProcessing" @click="$listeners.back()">{{ t.global.back}}</button>
                    <button v-on:click="stripeProceedCheckout()" :disabled="stripePaymentProcessing" class="btn btn-primary" type="submit">{{ stripePaymentProcessing ? t.checkout.processing+'...' : t.checkout.pay}}</button>
                </div>
                <div v-show="formPayment.payment_method != 'paypal_button' && formPayment.payment_method != 'stripe'" class="mt-3">
                    <!-- Default buttons -->
                    <button class="btn btn-secondary me-2" type="button" :disabled="formPayment.busy" @click="$listeners.back()">{{ t.global.back}}</button>
                    <button class="btn btn-primary" type="submit" :disabled="formPayment.busy">{{ formPayment.busy ? t.checkout.processing+'...' : (cart.total > 0 ? t.checkout.pay : t.checkout.order) }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Form from 'vform'
import { loadScript } from "@paypal/paypal-js"
export default {
    data() {
        return Object.assign({
            settings: settings,
            paymentMethodsLoaded: false,
            paymentMethods: [],
            formPayment: new Form({
                payment_method: null,
                last_digits: '', // for basic atm payment method
                terms_and_conditions: false
            }),
            paypalInit: false,
            stripeInitiated: false,
            stripeClientSecret: '',
            stripePaymentProcessing: false,
            stripe: null,
            stripePaymentElement: null,
            stripeElements: null,
            stripeError: '',
        }, this.$attrs)
    },
    computed: {
        ...Vuex.mapGetters(['loaded', 'cart']),
    },
    async mounted() {
        if (this.loaded) {
            // await this.stripeGetClientSecret()
            await this.getPaymentMethods()
            if (this.paymentMethods.find((paymentMethod) => paymentMethod.code == 'stripe')) {
                this.stripeInit()
            }
        }
    },
    watch: {
        loaded(newloaded, oldloaded) {
            this.getPaymentMethods()
        }
    },
    methods: {
        async getPaymentMethods() {
            await axios
            .get("/ajax/checkout/payment-methods")
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response)=>{
                this.paymentMethods = response.data
                if (!this.formPayment.payment_method) {
                    this.formPayment.payment_method = this.paymentMethods[0].code
                }
                if (!this.config.modules.demo_mode) {
                    if (!this.paypalInit && this.paymentMethods.find((paymentMethod) => paymentMethod.code == 'paypal_button')){
                        this.loadPaypalScript()
                    }
                }
                this.paymentMethodsLoaded = true
            });
        },
        selectPaymentMethod(paymentMethod) {
            if (!this.formPayment.busy) {
                this.formPayment.payment_method = paymentMethod.code
            }
        },
        async stripeGetClientSecret() {
            await axios
            .get("/ajax/stripe-client-secret")
            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
            .then((response)=>{
                this.stripeClientSecret = response.data
            });
        },
        async stripeInit() {
            await this.stripeGetClientSecret()
            this.stripe = Stripe(this.config.stripe_publishable_key);
            const appearance = {
                theme: 'stripe',
                variables: {
                    fontFamily: 'system-ui, sans-serif',
                    fontSizeBase: '0.8rem',
                    colorPrimary: '#212529',
                    borderRadius: '0px',
                }};
            this.stripeElements = this.stripe.elements({clientSecret: this.stripeClientSecret, appearance});
            const options = {};
            this.stripePaymentElement = this.stripeElements.create("payment", options);
            this.stripePaymentElement.mount("#payment-element");
            this.stripePaymentElement.on('change', ({error}) => {
                if (error) {
                    this.stripeError = error.message;
                } else {
                    this.stripeError = '';
                }
            });
            this.stripeInitiated = true
        },
        async stripeProceedCheckout() {
            this.stripePaymentProcessing = true

            if (!this.formPayment.terms_and_conditions) {
                this.formPayment.errors.set('terms_and_conditions', this.__('validation', 'accepted', {'attribute': this.t.checkout.terms_and_conditions}))
                this.stripePaymentProcessing = false
                return
            }
            var elements = this.stripeElements
            const { error } = await this.stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: this.url('order-confirmation/stripe'),
                },
            });

            if (error.type === "card_error" || error.type === "validation_error") {
                this.stripeError = error.message
                this.stripePaymentProcessing = false
            } else {
                this.stripeError = "An unexpected error occurred."
            }
        },
        loadPaypalScript () {
            var self = this
            loadScript({
                'client-id': window.paypal_client_id,
                'currency': currency.code.toUpperCase()
            })
            .then((paypal) => {
                this.paypalInit = true
                paypal.Buttons({
                    // Sets up the transaction when a payment button is clicked
                    createOrder: (data, actions) => {
                        this.formPayment.busy = true
                        var value = currency.decimals ? this.cart.total/100 : this.cart.total
                        return actions.order.create({
                            noshipping: 1,
                            purchase_units: [{
                                amount: {
                                    value: value.toString() // Can also reference a variable or function
                                }
                            }]
                        });
                    },
                    // Finalize the transaction after payer approval
                    onApprove: (data, actions) => {
                        return actions.order.capture().then(function(orderData) {
                            axios
                            .post("ajax/checkout/paypal-payment", {
                                order_id: orderData.id
                            })
                            .catch((error) => { Vue.notify({text: error.message, type: 'error'})  })
                            .then((response)=>{
                                if (response.data.success) {
                                    window.location.href = self.url('order-confirmation/paypal_button')
                                } else {
                                    Vue.notify({text: response.data.message, type: 'error'})
                                }
                            });
                        });
                    },
                    onCancel: (data, actions) => {
                        this.formPayment.busy = false
                    },
                    style: {
                        layout: 'horizontal',
                        color:  'black',
                        shape:  'rect',
                        height:  34,
                        tagline: false
                    }
                })
                .render("#paypal-button-container")
                .catch((error) => {
                    console.error("failed to render the PayPal Buttons", error);
                });
            })
            .catch((error) => {
                console.error("failed to load the PayPal JS SDK script", error);
            });
        },
        async submitPayment () {
            const response = await this.formPayment.post(this.url('ajax/checkout/submit-payment'))
            if (response.data.success) {
                this.formPayment.busy = true
                window.location.href = response.data.url
            } else if (response.data.success == false) {
                this.notify({text: response.data.message, type: 'error'})
                this.$store.dispatch("getCart");
            }
        },
    },
    created() {
        EventBus.$on('cart-changed', () => {
            this.getPaymentMethods()
        });
    },
}
</script>
